export default "__VITE_ASSET__CgvEpM73__"